import * as React from 'react';
import cx from 'clsx';
import { JackpotTier, JackpotBoxScale } from '../../types';

import styles from './JackpotBoxItem.module.scss';

interface JackpotBoxItemProps extends Pick<JackpotTier, 'winMessage' | 'name'> {
  scale: JackpotBoxScale;
  children: React.ReactNode;
}

export const JackpotBoxItem = ({
  scale,
  name,
  winMessage,
  children,
}: JackpotBoxItemProps) => {
  return (
    <>
      <div className={styles.jackpotNameContainer}>
        <div className={styles.jackpotName}>
          <span
            className={cx({
              [styles.jackpotNameTiny]: scale === 'tiny',
              [styles.jackpotNameSmall]: scale === 'small',
              [styles.jackpotNameMedium]: scale === 'medium',
            })}
          >
            {name}
          </span>
          {winMessage && (
            <span className={styles.jackpotMessage}>{winMessage}</span>
          )}
        </div>
      </div>
      <div className={styles.jackpotValue}>{children}</div>
    </>
  );
};
